<field-document-readonly *ngIf="field.readonly; else editable" [field]="field"></field-document-readonly>
<ng-template #editable>
  <field-document-single *ngIf="!field.multiple" [formGroup]="formGroup" [field]="field"></field-document-single>
  <field-document-multiple *ngIf="field.multiple" [formGroup]="formGroup" [field]="field"></field-document-multiple>
</ng-template>
